import React from 'react';
import { Form, Select, Input, Button, Modal, Row, Col, Spin, Icon, Switch, InputNumber } from 'antd';
import { openNotification } from '../../util/notificaciones';
import Articulo from '../../services/Articulos';
import { sanitizerTexto } from '../../util/utilerias';
import MinimosEstandaresRequest from '../../services/MinimosEstandares';
import CatalogosRequest from '../../services/Catalogos';
import BaseComponent from '../Common/BaseComponent';
const { Option } = Select;
const { Search } = Input;

/**
 * Clase para ver el formulario de catálogo Oxxo
 */
class FormMinimosEstandares extends BaseComponent {
    state = {
        bloquearBotones: false,
        cargando: false,
        mostrarModalConfirm: false,
        arrArticulosBusqueda: [],
        estatus_articulo: false,
        unidad_medida_text: '',
        arrMaquinas: [],
    }

    /**
     * Cargar datos cuando entra al módulo
     */
    componentDidMount = () => {
        let state = { ...this.state }
        this.setState(state, () => {
            CatalogosRequest.ListarMaquinas()
                .then(response => {
                    state.arrMaquinas = response.data;
                    state.arrMaquinas.push({id:147852, nombre: 'OTROS'})
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false })
                    openNotification(
                        "Ha ocurrido un error al cargar las máquinas.",
                        "Error al cargar las máquinas",
                        false
                    )
                })
        })
    }

    /** Cada vez que demos clic a un boton que muestre el 
     *  modal del formulario, se manda llamar.
     * */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.articulo !== prevProps.articulo) {
            if (this.props.articulo) {
                state.arrArticulosBusqueda.push(this.props.articulo?.articulo)
                this.setState(state)
            }

        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de sitios tránsito
     */
    handleCancel = () => {
        this.setState({ arrArticulosBusqueda: [] })
        this.props.cancel(false);
        this.props.form.resetFields();
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en buscar en input search
     * @param: value. valor del input search
     * @return: nada.
     */
    buscarArticulo = (value) => {
        let state = { ...this.state }
        if (value.trim()) {
            const { setFieldsValue } = this.props.form
            setFieldsValue({
                articulo: null
            })
            this.setState({ cargando: true }, () => {
                Articulo.ListarArticulos({ filtro: value })
                    .then(response => {
                        state.arrArticulosBusqueda = response.data.results
                        state.cargando = false;
                        this.setState(state)
                        if (!response.data.results.length) openNotification(
                            "No se ha encontrado un artículo con el código / descripción ingresado.",
                            "Verificar búsqueda",
                            false
                        )
                    })
                    .catch(err => {
                        this.setState({ cargando: false })
                        openNotification(err?.response?.data?.cuerpo, err?.response?.data?.cuerpo, false)
                    })
            })
        }
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en guardar la edición de sitios
     * @param: nada.
     * @return: nada.
     */
    editarArticulos = () => {
        let state = { ...this.state };
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let editar = this.props.type === 2 ? true : null
                let ruta;
                values.editar = editar
                if (this.props.drive_selected?.length === 1) values.id = this.props.articulo?.id
                if (this.props.drive_selected?.length > 1 && this.props.rows_selected.length > 1) {
                    values.minimos_estandares_ids = this.props.rows_selected?.map(item => item.id)
                } 
                values.sitios = this.props.drive_selected
                values.articulo = this.props.drive_selected?.length > 1 ? this.props.articulo_selected : values.articulo
                if (this.props.type === 1 && this.props.rows_selected.length < 2) {
                    ruta = MinimosEstandaresRequest.NuevoMinimo(values)
                }
                if (this.props.type === 1 && this.props.rows_selected.length > 1) {
                    ruta = MinimosEstandaresRequest.EditarMinimoMasivo(values)
                }
                if (this.props.type === 2 && this.props.rows_selected.length < 2) {
                    ruta = MinimosEstandaresRequest.EditarMinimo(values)
                }
                this.setState({ bloquearBotones: true, cargando: true }, () => {
                    ruta.then(response => {
                        state.arrArticulosBusqueda = [];
                        state.cargando = false;
                        state.bloquearBotones = false;
                        openNotification(response?.data?.cuerpo, response?.data?.titulo, true)
                        this.props.cancel(true);
                        this.setState(state)
                        this.props.form.resetFields();
                    }).catch(err => {
                        this.setState({ cargando: false, bloquearBotones: false })
                        openNotification(err?.response?.data?.cuerpo, err?.response?.data?.titulo, false)
                    })
                })
            }
        })
    }

    /**
     * Se cambia el combo artículos
     * * @param: value. id del artículo seleccionado
     */
    handleChangeArticulo = (value) => {
        let state = { ...this.state }
        let unidad_medida = state.arrArticulosBusqueda.filter(item => item.id === value)
        state.unidad_medida_text = unidad_medida[0]?.unidad_compra
        this.setState(state)
        this.props.form.setFieldsValue({
            um: state.unidad_medida_text,
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let tipo_form = this.props.type
        let drives = this.props.drive_selected;
        let rows = this.props.rows_selected
        // 1 = Nuevo , 2 = Editar , 3 = Detalle
        let titulo_form = (tipo_form === 1 && rows?.length < 2) ? "Nuevo" : (tipo_form === 1 && rows?.length > 1) ? "Edición masiva" : tipo_form === 2 ? "Editar" : tipo_form === 3 ? "Ver detalle" : undefined
        return (
            <div>
                <Modal
                    title={`${titulo_form} mínimo estándar`}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    width={this.state.isPos ? "95%" : "60%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-articulo-minimo"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={tipo_form !== 3 ? 'btnVerCrearGuardar' : 'display-none'}
                                key="submit"
                                id="boton-guardar-form-articulo-minimo"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={() => {
                                    if (tipo_form === 2) {
                                        this.props.form.validateFields((err, values) => {
                                            if (!err) {
                                                this.setState({ mostrarModalConfirm: true })
                                            }
                                        })
                                    } else {
                                        this.editarArticulos()
                                    }
                                }}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form>
                            <Row gutter={24}>
                            <Col className={(tipo_form === 3 || tipo_form === 2 || drives?.length > 1) ? 'display-none' : ''} span={12}>
                                    <Form.Item
                                        label={tipo_form === 3 ? <b>Buscar artículo por Código / Descripción</b> : 'Buscar artículo por Código / Descripción'}
                                        colon={tipo_form !== 3 ? true : false}
                                    >
                                        {getFieldDecorator('buscar_articulo', {
                                            rules: [
                                                { required: false },
                                                { whitespace: true, message: 'Por favor, ingrese Código / Descripción.' }
                                            ]
                                        })(
                                            <Search
                                                className={tipo_form !== 3 ? 'btn-buscar-articulo-form' : 'disableInputText'}
                                                disabled={tipo_form !== 3 ? false : true}
                                                id="input-search-articulo-minimos-form"
                                                placeholder="Ingrese Código / Descripción"
                                                enterButton="Buscar"
                                                onSearch={value => { this.buscarArticulo(value) }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={(drives?.length > 1) ? 'display-none' : ''} span={12}>
                                    <Form.Item
                                        label={tipo_form === 3 ? <b>Artículo</b> : 'Artículo'}
                                        colon={tipo_form !== 3 ? true : false}
                                    >
                                        {getFieldDecorator('articulo', {
                                            rules: [
                                                { required: (tipo_form === 3 || drives?.length > 1) ? false : true, message: 'Por favor, seleccione un artículo.' },
                                            ],
                                            initialValue: (
                                                this.props.articulo?.articulo?.id
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-articulo-form-articulo-minimos"
                                                className={(tipo_form === 3 || tipo_form === 2 || (tipo_form === 1 && !this.state.arrArticulosBusqueda.length)) ? 'disableInputText' : ''}
                                                disabled={(tipo_form === 3 || tipo_form === 2 || (tipo_form === 1 && !this.state.arrArticulosBusqueda.length)) ? true : false}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={tipo_form === 1}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                onChange={this.handleChangeArticulo}
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrArticulosBusqueda.length > 0 &&
                                                    this.state.arrArticulosBusqueda.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj?.id}
                                                                value={obj?.id}>
                                                                {obj?.codigo_descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={(drives?.length > 1) ? 'display-none' : ''} span={12}>
                                    <Form.Item
                                        label={tipo_form === 3 ? <b>Unidad de medida</b> : 'Unidad de medida'}
                                        colon={false}
                                    >
                                        {getFieldDecorator('um', {
                                            rules: [
                                                { required: false },
                                            ],
                                            initialValue: (
                                                this.props.articulo?.articulo?.unidad_compra ?? null
                                            )
                                        })(
                                            <Input
                                                id='input-unidad-medida-form-minimos'
                                                className={'disableInputText'}
                                                disabled={true}
                                            >
                                            </Input>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={tipo_form === 3 ? <b>Máquina</b> : 'Máquina'}
                                        colon={tipo_form !== 3 ? true : false}
                                    >
                                        {getFieldDecorator('maquina', {
                                            rules: [
                                                { required: tipo_form !== 3 ? true : false, message: 'Por favor, seleccione una máquina.' },
                                            ],
                                            initialValue: (
                                                this.props.articulo?.maquina
                                            )
                                        })(
                                            <Select
                                                allowClear={true}
                                                id="select-maquina-form-articulo-minimos"
                                                className={tipo_form === 3 ? 'disableInputText' : ''}
                                                disabled={tipo_form === 3 ? true : false}
                                                defaultActiveFirstOption={false}
                                                style={{ width: "100%" }}
                                                showArrow={tipo_form !== 3}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrMaquinas.length > 0 &&
                                                    this.state.arrMaquinas.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.nombre}>
                                                                {obj.nombre}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        label={tipo_form === 3 ? <b>Cantidad</b> : 'Cantidad'}
                                        colon={tipo_form !== 3 ? true : false}
                                    >
                                        {getFieldDecorator('cantidad', {
                                            rules: [
                                                { required: tipo_form !== 3 ? true : false, message: 'Por favor, ingrese cantidad.' }
                                            ],
                                            initialValue: (
                                                this.props.articulo?.cantidad ?? null
                                            )
                                        })(
                                            <InputNumber
                                                type="number"
                                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                                parser={value => String(value).replace(/[,.-]$/, '')}
                                                min={0}
                                                maxLength={5}
                                                max={99999}
                                                placeholder='Ingrese cantidad'
                                                style={{ width: '100%' }}
                                                className={tipo_form === 3 ? 'disableInputText' : ''}
                                                disabled={tipo_form === 3 ? true : false}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col className={(tipo_form === 1 && this.props.rows_selected.length === 0) ? 'display-none' : ''} span={12}>
                                    <Form.Item
                                        label={tipo_form === 3 ? <b>Estatus</b> : 'Estatus'}
                                        colon={tipo_form !== 3 ? true : false}
                                    >
                                        {getFieldDecorator('activo', {
                                            valuePropName: 'checked',
                                            rules: [{
                                                required: (tipo_form === 2 || this.props.rows_selected.length) ? true : false,
                                                message: 'Por favor, seleccione el estatus del artículo.'
                                            }],
                                            initialValue: (
                                                this.props.articulo?.activo ?? true
                                            )
                                        })(
                                            <Switch
                                                className={this.props.form.getFieldValue("activo") ? "colorSwitchActivo" : "colorSwitchInactivo"}
                                                disabled={tipo_form === 3}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Confirmar</p>}
                    onCancel={() => {
                        this.setState({ mostrarModalConfirm: false })
                    }}
                    centered={true}
                    visible={this.state.mostrarModalConfirm}
                    maskClosable={false}
                    footer={[
                        <Button
                            id='regresar-boton-confirmar-editar-articulo-oxxo'
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarModalConfirm = false;
                                this.setState(state);
                            }}>
                            Regresar
                        </Button>,
                        <Button
                            id='guardar-boton-confirmar-editar-articulo-oxxo'
                            className="btnVerCrearGuardar"
                            key="submit"
                            type="primary"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarModalConfirm = false;
                                this.setState(state, this.editarArticulos);
                            }}
                        >
                            Guardar
                        </Button>
                    ]}
                >
                    <p><b>¿Está seguro de editar la información del artículo?</b> Esto afectará
                            a la información que esté relacionada con el artículo.</p>
                </Modal>
            </div>
        )
    }

}

export default Form.create()(FormMinimosEstandares);